module.exports = __webpack_public_path__ + "img/photo2.c756bf9d.png";